
import $ from 'jquery';
import config from './../../../config';

export default function send_auth( data ){
	return dispatch => {
		
		$.ajax({
			method: 'post',
			url: config.apiurl + 'auth/',
			data: {
			  user: data.username,
			  password: data.password 
			}
		})
		.then(function (response) {
			dispatch( setDispatch( response ) )
		})

	}
}

export function setDispatch( login ){
	return {
		type: "SEND_AUTH",
		login
	}
}



// WEBPACK FOOTER //
// ./src/pages/login/actions/login.action.js